import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import { TopBar } from './TopBar';
import { Sidebar } from './Sidebar';
import { ContentArea } from './ContentArea';
import { ImpersonationBanner } from './ImpersonationBanner';
import { ActiveProjectProvider } from '../../context/ActiveProjectContext';

export function AppShell() {
  return (
    <ActiveProjectProvider>
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <ImpersonationBanner />
        <Sidebar />
        <TopBar />
        <ContentArea>
          <Outlet />
        </ContentArea>
      </Box>
    </ActiveProjectProvider>
  );
}
